import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './index.css';

declare const __DEV_AUTH_MOCK__: boolean;

// Sicherheits-Fail-Fast: Der Dev-Mock akzeptiert JEDES Passwort und leitet die
// Rolle client-seitig aus der E-Mail ab (admin@… → Admin). Die Trennung
// „echte Supabase-Auth vs. jeder-kommt-rein“ hängt allein an der Build-Konstante
// __DEV_AUTH_MOCK__ (vite.config.ts: false bei command==='build'). Käme ein
// Production-Bundle je mit aktivem Mock heraus (falsches Build-Kommando,
// Preview-Build, Fehlkonfiguration), stünde die App offen. Dann lieber hart
// abbrechen als eine scheinbar funktionierende, ungeschützte App ausliefern.
if (import.meta.env.PROD && __DEV_AUTH_MOCK__) {
  throw new Error(
    'SECURITY: Production build shipped with __DEV_AUTH_MOCK__ enabled — ' +
      'Mock-Auth akzeptiert jedes Passwort. Build abgebrochen. ' +
      'Deploy nur aus `vite build`.',
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
